module.exports = __webpack_public_path__ + "img/groundplan.ff446e65.svg";